import { useDispatch } from 'react-redux';

import { type PublicClip } from '@air/api';
import { updateContentCollectionClipsAction } from '@air/feature-content-collection/redux';
import { ClipUtils } from '@air/utils-clips';

import { usePublicWorkspace } from '~/components/PublicWorkspaceProvider';
import { useEventSubscription } from '~/hooks/useEventSubscription';

export const useHandleContentCollectionClipUpdated = (clips: PublicClip[]) => {
  const { workspaceId } = usePublicWorkspace();
  const dispatch = useDispatch();

  useEventSubscription({
    currentWorkspaceId: workspaceId,
    event:
      clips.length > 0
        ? {
            eventType: 'System.Clip.updated',
          }
        : undefined,
    options: {
      onUpdate: async ({ data: { clipId, updates: updatedClip } }) => {
        if (ClipUtils.isTranscodeFinished(updatedClip.status) && clips.some((c) => c.id === clipId)) {
          const localClip = clips.find((c) => c.id === clipId);
          if (!localClip) {
            return;
          }

          dispatch(
            updateContentCollectionClipsAction({
              clips: [
                {
                  ...localClip,
                  ...updatedClip,
                  // we re-assign these values so the server doesn't overwrite any local values set by the user
                  // after the clip has transcoded
                  title: localClip.title,
                  description: localClip.description,
                  customFields: localClip.customFields,
                },
              ],
            }),
          );
        }
      },
    },
  });
};
